export const PIN_SIDEBAR = 'PIN_SIDEBAR';
export const UNPIN_SIDEBAR = 'UNPIN_SIDEBAR';

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';

export const SET_TIMESHEET_GROUP_BY = 'SET_TIMESHEET_GROUP_BY';

export const SET_PICK_SCHEDULE_LAYOUT = 'SET_PICK_SCHEDULE_LAYOUT';
